import * as React from "react";
import logoLight from "./logo-brokerlink-light.png";
import logoDark from "./logo-brokerlink-dark.png";

/**
 * Logo Brokerlink (celui du CRM) : version marine sur fond clair, version blanche en mode sombre.
 * Les deux images sont rendues ; la classe `dark` sur <html> choisit celle qui s'affiche.
 */
export const Hestia = ({ className = '', ...props }) => {
  return (
    <>
      <img src={logoLight} alt="Brokerlink" className={`${className} dark:hidden`} {...props} />
      <img src={logoDark} alt="Brokerlink" aria-hidden="true" className={`${className} hidden dark:block`} {...props} />
    </>
  );
};
